<template>
  <custom-dialog
    class="contract-approval-dialog"
    width="450px"
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
  >
    <div class="dialog-body">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
      >
        <el-form-item :label="$t('crm_contract_approval_dialog.sfsptg')">
          <el-switch v-model="form.isPass"></el-switch>
        </el-form-item>
        <el-form-item
          :label="$t('crm_contract_approval_dialog.shen_pi_yi_jian')"
          prop="remark"
        >
          <el-input
            type="textarea"
            v-model="form.remark"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button
        type="primary"
        @click="onConfirm"
      >{{
        $t('Common.com_confirm')
      }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis';

// 统一审批接口type
const type = 'transfer_order';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        isPass: true,
        remark: ''
      },
    };
  },

  computed: {
    rules() {
      return {
        remark: {
          required: true,
          message: this.$t('Common.com_required'),
        }
      };
    },
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const bizId = this.model.data.orderId;
          const remark = this.form.remark;
          const basePath = this.form.isPass ? apis.apsApproveApprovalAapproveYes : apis.apsApproveApprovalApproveNo;
          const fullPath = `${basePath}/${type}/${bizId}`;
          this.$postJSON(fullPath, { remark }, true).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_handle_success')
            });
            this.$emit('success');
            this.closeDialog();
          });
        }
      });


    }
  }
};
</script>

<style></style>
